import styles from "./main-news.module.scss";
import { News } from "../../../types/types";
import { Link } from "react-router-dom";

const MainNews = ({
  title,
  description,
  preview,
  from,
  level,
  avatar,
  id,
  date,
}: News) => {
  const formatDate = (date: Date): string => {
    return date.toLocaleDateString("ru-RU").replace(/\//g, ".");
  };

  return (
    <Link to={`/news/${id}`} className={styles.news}>
      <div className={styles.preview__wrap}>
        <img src={preview} alt={title} className={styles.news__preview} />
        <p className={styles.news__name}>{title}</p>
      </div>
      <div className={styles.news__info}>
        <img src={avatar} alt={from} className={styles.news__avatar} />
        <div className={styles.info__text}>
          <p className={styles.news__from}>{from}</p>
          <p className={styles.news__level}>{level}</p>
        </div>
        <p className={styles.news__date}>{formatDate(date)}</p>
      </div>
      <p className={styles.news__description}>{description}</p>
      <p className={styles.news__action}>Подробнее...</p>
    </Link>
  );
};
export default MainNews;
